import { useEffect } from 'react';

/**
 * Custom hook for handling modal-specific scenarios in Google Reviews
 * @param {boolean} hasGoogleReviewsSection - Whether this is the modal variant
 * @param {Function} forceRecalculation - Function to force scroll recalculation
 */
export function useModalScrollRecalculation(hasGoogleReviewsSection, forceRecalculation) {
  useEffect(() => {
    // If this is the modal variant (hasGoogleReviewsSection = false)
    if (!hasGoogleReviewsSection) {
      // Force recalculation after modal opens
      const timeoutId = setTimeout(() => {
        forceRecalculation();
      }, 100);

      // Also try when the component is fully mounted
      const timeoutId2 = setTimeout(() => {
        forceRecalculation();
      }, 500);
      return () => {
        clearTimeout(timeoutId);
        clearTimeout(timeoutId2);
      };
    }
  }, [hasGoogleReviewsSection, forceRecalculation]);
}